<template>
    <div class="button-sm button-sm-delete" :disabled="disabled">
        <div class="button-sm__btn button-sm-delete__btn" :disabled="disabled">

            <svg v-if="icon === 'basket'" class="delete-icon" viewBox="0 0 16 17" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.81818 13.6173C5.81818 13.8137 5.65909 13.9665 5.45455 13.9665H4.72727C4.52273 13.9665 4.36364 13.8137 4.36364 13.6173V5.93575C4.36364 5.73935 4.52273 5.58659 4.72727 5.58659H5.45455C5.65909 5.58659 5.81818 5.73935 5.81818 5.93575V13.6173ZM8.72727 13.6173C8.72727 13.8137 8.56818 13.9665 8.36364 13.9665H7.63636C7.43182 13.9665 7.27273 13.8137 7.27273 13.6173V5.93575C7.27273 5.73935 7.43182 5.58659 7.63636 5.58659H8.36364C8.56818 5.58659 8.72727 5.73935 8.72727 5.93575V13.6173ZM11.6364 13.6173C11.6364 13.8137 11.4773 13.9665 11.2727 13.9665H10.5455C10.3409 13.9665 10.1818 13.8137 10.1818 13.6173V5.93575C10.1818 5.73935 10.3409 5.58659 10.5455 5.58659H11.2727C11.4773 5.58659 11.6364 5.73935 11.6364 5.93575V13.6173ZM5.45455 2.79329L6.01136 1.51669C6.04545 1.47304 6.13636 1.40757 6.20455 1.39666H9.80682C9.86364 1.40756 9.96591 1.47304 10 1.51669L10.5455 2.79329H5.45455ZM16 3.14246C16 2.94605 15.8409 2.79329 15.6364 2.79329H12.125L11.3295 0.971118C11.1023 0.436464 10.4205 0 9.81818 0H6.18182C5.57954 0 4.89773 0.436464 4.67045 0.971118L3.875 2.79329H0.363637C0.159091 2.79329 0 2.94605 0 3.14246V3.84079C0 4.0372 0.159091 4.18996 0.363637 4.18996H1.45455V14.5775C1.45455 15.7777 2.27273 16.7598 3.27273 16.7598H12.7273C13.7273 16.7598 14.5455 15.7341 14.5455 14.5339V4.18996H15.6364C15.8409 4.18996 16 4.0372 16 3.84079V3.14246Z"
                    fill="currentColor" />
            </svg>

            <svg v-if="icon === 'minus'" class="delete-icon" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              width="401.991px" height="401.991px" viewBox="0 0 401.991 401.991" style="enable-background:new 0 0 401.991 401.991;"
              xml:space="preserve">
              <g>
                <path d="M394,154.174c-5.331-5.33-11.806-7.995-19.417-7.995H27.406c-7.611,0-14.084,2.665-19.414,7.995
                  C2.662,159.503,0,165.972,0,173.587v54.82c0,7.617,2.662,14.086,7.992,19.41c5.33,5.332,11.803,7.994,19.414,7.994h347.176
                  c7.611,0,14.086-2.662,19.417-7.994c5.325-5.324,7.991-11.793,7.991-19.41v-54.82C401.991,165.972,399.332,159.5,394,154.174z"/>
              </g>
            </svg>
        </div>
        <p class="button-sm__text button-sm-delete__text" v-if="title">{{ title }}</p>
    </div>
</template>

<script>
export default {
  name: 'app-button-sm-remove',
  props: {
    disabled: Boolean,
    title: String,
    icon: {
      type: String,
      default: 'basket'
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.button-sm {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  cursor: pointer;
  user-select: none;

  &__btn {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color__brown;
    height: 30px;
    width: 30px;
    border-radius: 3px;
    transition: .3s;
    cursor: pointer;
    user-select: none;
    font-family: $font_main;
  }

  &__text {
    transition: .3s;
  }

  &[disabled] {
    color: $color_deactive;
    pointer-events: none;

    .button-sm__btn {
      background: $color_deactive;
      box-shadow: none;
    }
  }
}

.button-sm-delete {

  // &__btn {
  //   background: $button_color_second;
  //   box-shadow: 0px 2px 2px #4C095C;
  // }

  &:hover {
    .delete-icon {
      color: $color__orange;
    }
  //   .button-sm-delete__text {
  //     color: #AC1082;
  //   }
  }

  // &:active {
  //   .button-sm-delete__btn {
  //     box-shadow: inset 0px 4px 4px rgba(44, 4, 48, 0.54);
  //   }
  // }
}
</style>
